export class SearchQueryModel {
  queryString?: string;
  keyword?: string;
  isEmpty: boolean;
  table?: string;
  searchQuery?: any;
  advancedSearchData?: any;
}
export interface EntityInputModel {
  keyword: string;
  entity_code: string;
  name: string;
  type: string;
  status: string;
  phone: string;
  email: string;
  updated_date_from: string;
  updated_date_to: string;
  search_word: string;
  txn_type: string;
  hdr_updated_date_from: string;
  hdr_updated_date_to: string;
}

export interface SearchEvent {
  isEmpty: boolean;
  basicSearchMode: boolean;
  basicQuery?: string;
  form?: { [key: string]: any };
}